import { getPaginationReducer } from 'components/pagination/pagination.reducer';
import { courseAssignmentsActionTypes } from './course-assignments.actions';

export const assignments = getPaginationReducer({
    actionTypes: courseAssignmentsActionTypes,
    limit: 10,
    paginationStyle: 'infinite',
});
